import { ProductOverview } from '../index-details/styled'
import { getProductBySymbol } from 'indices-list'
import { UnknownProductTypeError } from '../../utils/errors'
import MetaTags from 'components/meta-tags'
import type React from 'react'
import { APP_URL } from '../../app-constants/index'
import { getStakingCoverInformation, withApr } from './services'
import { getStakingStorage } from './storage'
import { InvestComponent } from 'components/widgets/invest-component'
import { StakingCoverInformation } from './staking-cover'

export const StakingPageWrapper: React.FC = () => {
  const stakingSymbol = 'ephtr'
  const product = getProductBySymbol(stakingSymbol)
  if (!product) {
    throw new UnknownProductTypeError(stakingSymbol)
  }

  const { longName, description } = product
  const storage = getStakingStorage()
  return (
    <>
      <MetaTags title={longName} description={description} address={`${APP_URL}/staking`} />
      <ProductOverview>
        <StakingCoverInformation
          coverInformation={getStakingCoverInformation(storage.totalStaked, storage.userStaked)}
          productMetaData={product}
          tagLineModifier={withApr(storage.ytdReturns)}
        />
        <InvestComponent productMetadata={product} />
      </ProductOverview>
    </>
  )
}
